export default __webpack_public_path__ + "media/images/71-982cbbb8ad01a7d3027eb63b599a03ed.jpg";